import DOMPurify from 'dompurify';

export interface SanitizeHtmlOptions {
  anchorColor?: string;
}

function isSafeCssColor(value?: string): value is string {
  const normalizedValue = value?.trim();

  if (!normalizedValue) {
    return false;
  }

  if (typeof CSS !== 'undefined' && typeof CSS.supports === 'function') {
    return CSS.supports('color', normalizedValue);
  }

  return /^(#[0-9a-fA-F]{3,8}|(?:rgb|hsl)a?\([\d\s,.%/-]+\)|[a-zA-Z]+)$/.test(normalizedValue);
}

export function decodeHtmlEntities(value?: string | null): string {
  if (!value) {
    return '';
  }

  if (!value.includes('&lt;') && !value.includes('&gt;')) {
    return value;
  }

  return new DOMParser().parseFromString(value, 'text/html').body.textContent || '';
}

export function sanitizeHtmlContent(value?: string | null, options?: SanitizeHtmlOptions): string {
  if (!value) {
    return '';
  }

  const parsedDocument = new DOMParser().parseFromString(value, 'text/html');
  const anchorColor = isSafeCssColor(options?.anchorColor) ? options?.anchorColor.trim() : '';

  if (anchorColor) {
    parsedDocument.body.querySelectorAll('a').forEach((anchor) => {
      anchor.style.color = anchorColor;
      anchor.style.fontWeight = 'bold';
      anchor.style.textDecoration = 'underline';
    });
  }

  return DOMPurify.sanitize(parsedDocument.body.innerHTML, {
    USE_PROFILES: { html: true }
  });
}
